import { Link } from 'react-router-dom';
import { articlesMeta } from '@/mocks/articlesData';

export default function ArticleCards() {
  return (
    <section className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
            SEO Resource Hub
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Guides &amp; Reviews
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            In-depth articles covering everything from beginner tutorials to advanced shopping strategies
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articlesMeta.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden hover:border-primary-200 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-primary-600 text-[10px] md:text-xs font-semibold rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/40">
                  <span className="text-[10px] md:text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                    {article.readTime}
                  </span>
                  <span className="text-xs font-medium text-primary-500 flex items-center gap-1 group-hover:gap-1.5 transition-all">
                    Read More
                    <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}